// ** React Imports
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

// ** Custom Components
import Avatar from '../avatar/index';
// ** Utils
import { isUserLoggedIn } from '@utils';

// ** Store & Actions
import { useDispatch } from 'react-redux';

// ** Third Party Components
import { LogOut, Package, User } from 'react-feather';

// ** Reactstrap Imports
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/profile/default-avatar.jpg';
import { useLogout } from '../../../../../store/Auth/authHooks';
import { useTranslation } from 'react-i18next';

const UserDropdown = ({ user }) => {
  const logout = useLogout();
  const { t } = useTranslation();
  // ** Store Vars
  const dispatch = useDispatch();

  // ** State
  const [userData, setUserData] = useState(null);

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')));
    }
  }, []);

  //** Vars
  const userAvatar = (user && user.image) || defaultAvatar;

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex">
          <span className="user-name fw-bold">{user?.fullName}</span>
          <span className="user-status">{user?.jobTitle}</span>
        </div>
        <Avatar img={userAvatar} imgHeight="40" imgWidth="40" status="online" />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to="/account-settings">
          <User size={14} className="me-50" />
          <span className="align-middle">{t('MY_PROFILE')}</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="/login" onClick={logout}>
          <LogOut size={14} className="me-50" />
          <span className="align-middle">{t('LOGOUT')}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
